import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const servicesPath = language === 'en' ? '/services' : '/servizi';
  const resourcesPath = language === 'en' ? '/resources' : '/risorse';
  const contactPath = language === 'en' ? '/contact' : '/contatti';
  const quotePath = language === 'en' ? '/quote' : '/preventivo';

  return (
    <footer className="dark-footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-logo">{companyInfo.name}</h3>
            <p className="footer-description">
              {t.footer.tagline}
            </p>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-title">{t.footer.servicesTitle}</h4>
            <ul className="footer-links">
              <li><Link to={servicesPath}>{language === 'en' ? 'ISO 9001 Certification' : 'Certificazione ISO 9001'}</Link></li>
              <li><Link to={servicesPath}>{language === 'en' ? 'ISO 45001 Certification' : 'Certificazione ISO 45001'}</Link></li>
              <li><Link to={servicesPath}>{language === 'en' ? 'ISO 14001 Certification' : 'Certificazione ISO 14001'}</Link></li>
              <li><Link to={servicesPath}>{language === 'en' ? 'ISO 27001 Certification' : 'Certificazione ISO 27001'}</Link></li>
              <li><Link to={servicesPath}>{language === 'en' ? 'HSE Compliance' : 'Conformità HSE'}</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div className="footer-section">
            <h4 className="footer-title">{t.footer.resourcesTitle}</h4>
            <ul className="footer-links">
              <li><Link to={resourcesPath}>{t.footer.blogArticles}</Link></li>
              <li><Link to={resourcesPath}>{t.footer.guideFaq}</Link></li>
              <li><Link to={quotePath}>{t.footer.requestQuote}</Link></li>
              <li><Link to={contactPath}>{t.footer.contactUs}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h4 className="footer-title">{t.footer.contactTitle}</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={16} />
                <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
              </li>
              <li>
                <Phone size={16} />
                <a href={`tel:${companyInfo.phoneOffice}`}>{t.footer.office}: {companyInfo.phoneOffice}</a>
              </li>
              <li>
                <Phone size={16} />
                <a href={`tel:${companyInfo.phoneSales}`}>{t.footer.salesLabel}: {companyInfo.phoneSales}</a>
              </li>
              <li>
                <MapPin size={16} />
                <span>{companyInfo.address}</span>
              </li>
              <li className="footer-piva">
                <span>P.IVA: 01506460458</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              {t.footer.copyright.replace('{year}', new Date().getFullYear())} • P.IVA: 01506460458
            </p>
            <div className="footer-legal">
              <Link to="/privacy">{t.footer.privacy}</Link>
              <span className="footer-separator">|</span>
              <Link to="/terms">{t.footer.terms}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
